module.exports = {"TXTCLI_Game_Information":{"id":"TXTCLI_Game_Information","defaultMessage":"Информация про игру"}}